import React from "react";
import ValidatedInput from "../../../commonComponents/util/ValidatedInput";
import CurrencyFormatInput from "../../../commonComponents/util/CurrencyFormatInput";
import Modal from "../../../commonComponents/util/Modal";

export default class EditReconciliationBankBalanceModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      submitAttempted: false,
      report: props.report || {},
    };
  }

  onChange = (name, value) => {
    this.setState({ report: { ...this.state.report, [name]: value } });
  };

  continue() {
    if (!this.state.submitAttempted) this.setState({ submitAttempted: true });
    const report = this.state.report;
    if (report.statementBalance) {
      this.props.continue(report);
    }
  }

  render() {
    const { isIsraeli } = this.props;
    const { submitAttempted, report } = this.state;
    return (
      <Modal modalShowing={true}>
        <div className="modal-container">
          <div className="modal new-transaction-modal large-modal">
            <div className="bordered-modal-header">
              <div>
                <h4 className="page-header">Edit Bank Balance</h4>
              </div>
              <i className="icon ion-ios-close-empty" onClick={this.props.close} />
            </div>

            <div className="modal-section">
              <ValidatedInput
                input={
                  <CurrencyFormatInput
                    allowNegative={true}
                    allowZero={true}
                    isIsraeli={isIsraeli}
                  />
                }
                label="Bank Statement Balance"
                name="statementBalance"
                onChange={this.onChange}
                required={true}
                showRequiredError={submitAttempted}
                value={report.statementBalance}
                zeroAsValue={true}
              />
            </div>

            <div className="modal-btns text-right">
              <button className="btn btn-accent" onClick={this.props.close}>
                Cancel
          </button>
              <button
                className="btn btn-primary"
                onClick={this.continue.bind(this)}
              >
                Continue
          </button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/accountingComponents/fundDetails/NewBankReconciliation/EditReconciliationBankBalanceModal.jsx